import { HStack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { TypeUtils } from '../../../../../../framework/utils/UtilityTypes';
import {
  ClearButton,
  SearchButton,
} from '../../../../../components/StyledButton';
import { useFormItems } from '../../../../../hooks/formItems';
import { MatterSummarySearchParam } from '../../../../../models/gen/matterSummarySearchParam';

/**
 * 選択フォームプロパティ
 */
type SearchFormProps = {
  /**
   * 検索イベント
   */
  onSearch: Consumer<MatterSummarySearchParam>;
};

/**
 * 現場選択ダイアログ - 選択フォーム
 * @returns
 */
const SearchForm: React.FunctionComponent<SearchFormProps> = (props) => {
  const form = useFormContext<MatterSummarySearchParam>();
  const { FormDateRange, FormInput } =
    useFormItems<MatterSummarySearchParam>(form);

  return (
    <VStack as="form" onSubmit={form.handleSubmit(props.onSearch)} width="100%">
      <FormInput label="現場名" mode="edit" name="matterName" />
      <FormInput label="依頼元" mode="edit" name="customerName" />
      <FormDateRange
        formControlProps={{ isRequired: true }}
        forms={[{ name: 'dateFrom' }, { name: 'dateTo' }]}
        label="作業期間"
        mode="edit"
        onClickClear={(name) => form.setValue(name, '')}
      />
      <HStack justifyContent="end">
        <ClearButton onClick={() => form.reset()} />
        <SearchButton
          isDisabled={form
            .watch(['dateFrom', 'dateTo'])
            .some((value) => TypeUtils.isNilString(value))}
        />
      </HStack>
    </VStack>
  );
};

export default SearchForm;
